import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from './alert.service';
import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable()
export class ErrorService {
  constructor(private alertService: AlertService, private router: Router) {}

  httpError(err: Response | any): Observable<any> {
    try {
      err = err ? JSON.parse(err._body) : {};
    } catch (err) {
      // when response JSON doesn't parse then we most likely have a network issue
      this.router.navigate(['offline']);
      return Observable.throw(false);
    }
    switch (err.code) {
      case 'INVALID_REQUEST':
        this.fieldError(err);
        break;
      case 'UNAUTHORIZED':
        // this.router.navigate(['/login']);
        break;
      case 'ILLEGAL_STATE':
        this.illegalError(err);
        break;
      case 'EXTERNAL_ERROR':
        this.alertError(err);
        break;
      case 'INTERNAL_ERROR':
        this.alertError(err);
        break;
      default:
        this.unknownError(err);
    }
    return throwError(err);
  }

  fieldError(err): void {
    console.log('FIELD VALIDATION ERROR');
    console.log(err);
  }

  illegalError(err): void {
    if (err.description) {
      this.alertService.addAlert(this.alertService.createCustomAlertObj(err.description, 'warning', 5000));
    }
  }
  alertError(err): void {
    const customDesc = 'Something went wrong! Please try again';
    if (err.description) {
      this.alertService.addAlert(this.alertService.createCustomAlertObj(customDesc, 'warning', 5000));
    }
  }

  unknownError(err): void {
    console.log('UNKNOWN ERROR');
    console.log(err);
  }
}
